module.exports = __webpack_public_path__ + "img/image-map-poly-949f646b.png";